<template>
  <AppBtn size="x-large" primary>
    {{ $tt(`hero_cta_${countryKey || 'home'}`) }}
    <ChevronMarker dir="next" size="large" class="ms-2" />
  </AppBtn>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
const countryKey = inject(countryKeyInjectionKey, null);
</script>